/**
 * A set of utilities for defining the features.
 *
 * see here for more:
 * https://github.com/rjewson/fxhash-starter/blob/main/src/js/utils/features.js
 */

import { value } from "./random";

export const FX_Features = {};

export function addFeature(
  featureDescription,
  featureKeyName,
  featureDisplayValues,
  probabilities,
  values,
  report = true
) {
  let totalProbabilities = 0;
  let undefinedProbabilities = [];

  probabilities.forEach((p, i) => {
    if (p > 0) {
      // Sum up the total for the defined probabilities
      totalProbabilities += p;
    } else {
      // If no probabilitiy is defined (0) the add it to the bucket to be evenly distributed
      undefinedProbabilities.push(i);
    }
  });

  if (totalProbabilities > 1) {
    throw "Sum of probabilities exceeds 100%.";
  }

  if (totalProbabilities < 0.9999999) {
    // 0.9999999 to avoid rounding errors
    if (undefinedProbabilities.length === 0) {
      throw "Cannot cover all probabilities.";
    }
    // Distribute the unallocated probability evenly across the undefined feature values
    const remainingPropShare =
      (1 - totalProbabilities) / undefinedProbabilities.length;
    undefinedProbabilities.forEach((i) => {
      probabilities[i] = remainingPropShare;
    });
  }

  const chance = value(0, 1);
  let startPercent = 0;
  let choice = -1;
  for (let i = 0; i < probabilities.length; i++) {
    const endPercent = startPercent + probabilities[i];
    if (chance >= startPercent && chance < endPercent) {
      choice = i;
      break;
    }
    startPercent = endPercent;
  }
  if (report && window.$fxhashFeatures) {
    window.$fxhashFeatures[featureDescription] = featureDisplayValues[choice];
  }

  // Save the feature (code) value to the features object for easy retrieval
  FX_Features[featureKeyName] = values[choice];

  // Return the value to direct use
  return values[choice];
}
